/** Size variants for the loading spinner. */
export enum SpinnerSize {
  Sm = 'sm',
  Md = 'md',
  Lg = 'lg',
}
